/* src/api/supplierService.js ver 06 from 05 Jan 15 2026 9:46pm - SB120
   src/api/supplierService.js ver 05 from 04 Oct 18 2025 17:17 - Pagination for Inventory list, supplier list 
   src/api/supplierService.js ver 04 from 03 Oct 15 2025 17:51
   src/api/supplierService.js ver 03 from 02 Oct 7 2025 19:48 */
import { callCloudFunction } from './apiClient';

// export const getSuppliers = async (token, tenantid) => {
//     return callCloudFunction('supplierCrud', 'GET', null, null, token, null, { pathParams: {tenantid, operation: 'list' } });
// };

export const getSuppliers = async (token, tenantid, page = 1, limit = 20) => {
    console.log(`supplierService.js - tenantid = ${tenantid}`)
    return callCloudFunction('supplierCrud', 'GET', null, null, token, null, { pathParams: {tenantid, operation: 'list' }, queryParams: { page, limit } });
};

export const getSupplierById = async (id, token, tenantid) => {
    return callCloudFunction('supplierCrud', 'GET', null,  null, token, null, {pathParams: { tenantid, operation: 'getById', id } } );
};

export const addSupplier = async (supplierData, token, tenantid) => {
    return callCloudFunction('supplierCrud', 'POST', supplierData, null, token, null, { pathParams: {tenantid, operation: 'add'} });
};

export const updateSupplier = async (id, supplierData, token, tenantid) => {
    return callCloudFunction('supplierCrud', 'PUT', supplierData, null, token, null, {pathParams: { tenantid, operation: 'update', id } } );
};

// NEW ver 06: Helper to fetch all active supplier codes for dropdowns (for ItmVrntPkgSuplrsPrice)
export const getAllActiveSupplierCodesForDropdown = async (tenantid, token) => {
    // Calls supplierCrud 'listActvSuplrCds' operation directly
    return callCloudFunction('supplierCrud', 'GET', null, null, token, null, {
        pathParams: { tenantid, operation: 'listActvSuplrCds' } // operation is part of pathParams
    });
};